import { Field } from '../types'

export const fieldMap: Record<string, string> = {
  [Field.FirstName]: 'first_name',
  [Field.LastName]: 'last_name',
  [Field.Birthdate]: 'birthdate',
  [Field.Nationality]: 'nationality',
  [Field.SsnNumber]: 'ssn_serial',
  [Field.PersonalIdNumber]: 'personal_id_number',
}

export const getIsFieldLocked = (field: Field, lockedFields?: Array<string>) => {
  return lockedFields?.includes(fieldMap[field]!) || false
}

export const getIsFieldMasked = (field: Field, maskedFields?: Array<string>) => {
  return maskedFields?.includes(fieldMap[field]!) || false
}
